var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DF87E9E7-0CCA-4E11-A15A-EEB1A0EC58A4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Products---items",
    transform: "translate(-1324.000000, -501.000000)",
    stroke: "#E10210",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2634",
    transform: "translate(1325.000000, 502.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.167,4 L0.833,4 C0.37294682,4 0,4.37294682 0,4.833 L0,11.5 C0,12.880712 1.1192881,14 2.5,14 L7.5,14 C8.1630415,14 8.798926,13.7366077 9.267767,13.267767 C9.7366077,12.798926 10,12.1630415 10,11.5 L10,4.833 C10,4.37294682 9.627053,4 9.167,4 Z",
    id: "Vector-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,2 L7.2759998,0.553 C7.10673644,0.214270592 6.7606658,0.000202218172 6.3819998,0 L3.61800002,0 C3.23933426,0.000202218172 2.89326356,0.214270592 2.72400002,0.553 L2,2 L8,2 Z",
    id: "Vector-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.333,7.333 L3.333,10.666 M6.667,7.333 L6.667,10.666 M8,2 L10,2 M2,2 L0,2",
    id: "Vector-9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/Trash-red.30127666c8ca25d58d4f7677975514b5.svg";
export { ForwardRef as ReactComponent };